import { ApiClientError, api, unwrap } from "@lumberset/api-client";

export const NOT_ADMIN_MESSAGE = "This panel is for LumberSet admins.";

/** Thrown by the app layout when the signed-in person is not an Admin. */
export class NotAdminError extends Error {
  constructor(readonly email: string) {
    super(NOT_ADMIN_MESSAGE);
    this.name = "NotAdminError";
  }
}

/**
 * Whether the signed-in person may use this panel. Members and Staff who are
 * not Admins get a plain no; anything else (no network, a server fault) throws.
 */
export async function isAdmin(): Promise<boolean> {
  try {
    const { user } = await unwrap(api.ops.me.$get());
    return user.role === "admin";
  } catch (error) {
    if (error instanceof ApiClientError && error.status === 403) return false;
    throw error;
  }
}
